import { render, staticRenderFns } from "./DetailedGift.vue?vue&type=template&id=b726e7e2&scoped=true"
import script from "./DetailedGift.vue?vue&type=script&lang=ts"
export * from "./DetailedGift.vue?vue&type=script&lang=ts"
import style0 from "./DetailedGift.vue?vue&type=style&index=0&id=b726e7e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b726e7e2",
  null
  
)

export default component.exports